<template>
  <footer
    class="footer relative grid grid-cols-5 max-lg:block"
    :class="ui?.root"
  >
    <div :class="ui?.column">
      <h2
        v-if="false"
        class="mb-1 text-4xl font-bold text-accent-default"
        :class="ui?.logo"
      >
        {{ ORGANIZATION_DATA.title }}
      </h2>

      <img class="logo-image" src="@/assets/logo/logo-primary.svg" alt="Лого" />
      <span
        v-if="false"
        class="text-size-h5 font-medium text-content-default"
        :class="ui?.slogan"
      >
        {{ ORGANIZATION_DATA.slogan }}
      </span>

      <p
        class="mt-5 text-xs font-lato! text-content-default-secondary lg:mb-25 max-lg:max-w-1/3 max-md:max-w-2/3"
        :class="ui?.description"
      >
        {{ ORGANIZATION_DATA.description }}
      </p>

      <ClientOnly>
        <p
          v-if="!isMobile && !isSmallTablet"
          class="text-size-ultrasmall text-content-default-secondary"
          :class="ui?.copyright"
        >
          © 2026 СпортПортал. Все права защищены.
        </p>
      </ClientOnly>
    </div>

    <div :class="ui?.column"></div>

    <div class="flex flex-col justify-between max-lg:mt-6" :class="ui?.column">
      <ClientOnly>
        <UCollapsible
          :class="{
            'border-b': isMobile || isSmallTablet,
            'border-b-border-light': isMobile || isSmallTablet,
          }"
          :default-open="!isMobile"
        >
          <UButton
            class="group w-full px-0"
            variant="ghost"
            color="neutral"
            trailing-icon="i-local-chevron-right"
            :ui="{
              base: 'gap-3 py-4 font-semibold rounded-none justify-start',
              trailingIcon:
                'ml-auto w-6 h-6 group-data-[state=open]:rotate-90 transition-transform duration-200 lg:hidden',
            }"
          >
            {{ FOOTER_MENU[0]?.title }}
          </UButton>

          <template #content>
            <nuxt-link
              v-for="({ label, href }, linkIndex) in FOOTER_MENU[0]?.links"
              :key="linkIndex"
              :to="href"
              class="mb-2.5 block text-sm font-medium text-neutral-light"
              :class="ui?.link"
            >
              {{ label }}
            </nuxt-link>
          </template>
        </UCollapsible>
      </ClientOnly>

      <ClientOnly>
        <nuxt-link
          v-if="!isMobile && !isSmallTablet"
          to="/documents/privacy"
          target="_blank"
          class="mt-auto mb-2.5 block text-xs font-medium text-neutral-light"
          :class="ui?.link"
        >
          Политика конфиденциальности
        </nuxt-link>
      </ClientOnly>
    </div>

    <div class="flex flex-col justify-between" :class="ui?.column">
      <ClientOnly>
        <UCollapsible
          :class="{
            'border-b': isMobile || isSmallTablet,
            'border-b-border-light': isMobile || isSmallTablet,
          }"
          :default-open="!isMobile"
        >
          <UButton
            class="group w-full px-0"
            variant="ghost"
            color="neutral"
            trailing-icon="i-local-chevron-right"
            :ui="{
              base: 'gap-3 py-4 font-semibold rounded-none justify-start',
              trailingIcon:
                'ml-auto w-6 h-6 group-data-[state=open]:rotate-90 transition-transform duration-200 lg:hidden',
            }"
          >
            {{ FOOTER_MENU[1]?.title }}
          </UButton>

          <template #content>
            <template
              v-for="({ label, href, onClick }, linkIndex) in FOOTER_MENU[1]
                ?.links"
              :key="linkIndex"
            >
              <ULink
                class="block text-sm font-medium text-neutral-light mb-2.5"
                :class="ui?.link"
                :to="href"
                @click="onClick"
              >
                {{ label }}</ULink
              >
            </template>
          </template>
        </UCollapsible>
      </ClientOnly>

      <ClientOnly>
        <nuxt-link
          v-if="!isMobile && !isSmallTablet"
          to="/documents/personal-data"
          target="_blank"
          class="mt-auto mb-2.5 block text-xs font-medium text-neutral-light"
          :class="ui?.link"
        >
          Политика обработки персональных данных
        </nuxt-link>
      </ClientOnly>
    </div>

    <div class="max-lg:mt-10" :class="ui?.column">
      <ClientOnly>
        <div
          v-if="!isMobile && !isSmallTablet"
          class="mt-4 mb-4 font-semibold text-content-default"
          :class="ui?.infoTitle"
        >
          Информация (мок)
        </div>
      </ClientOnly>
      <a
        class="block typo-paragraph-xl-medium text-content-default mb-1"
        :href="`tel:${ORGANIZATION_DATA.phone}`"
        :class="ui?.phone"
      >
        {{ ORGANIZATION_DATA.phone }}
      </a>

      <span
        class="block typo-paragraph-sm-regular text-content-default-secondary"
      >
        {{ ORGANIZATION_DATA.workTime }}
      </span>

      <a
        class="block typo-paragraph-xl-medium text-content-default mt-6"
        :href="`mailto:${ORGANIZATION_DATA.email}`"
        :class="ui?.email"
      >
        {{ ORGANIZATION_DATA.email }}
      </a>
    </div>

    <UButton
      class="absolute right-15 bottom-10 max-md:right-5 max-md:bottom-5"
      :class="ui?.scrollTopBtn"
      icon="i-local-chevron-right"
      variant="outline"
      :ui="{
        leadingIcon: '-rotate-90',
      }"
      @click="scrollToTop"
    />

    <ClientOnly>
      <template v-if="isMobile || isSmallTablet">
        <nuxt-link
          to="/documents/personal-data"
          target="_blank"
          class="mt-10 block text-xs font-medium text-neutral-light"
          :class="ui?.link"
        >
          Политика обработки персональных данных
        </nuxt-link>

        <nuxt-link
          to="/documents/privacy"
          target="_blank"
          class="block text-xs font-medium text-neutral-light mt-4.5"
          :class="ui?.link"
        >
          Политика конфиденциальности
        </nuxt-link>

        <ClientOnly>
          <p
            class="mt-4 text-size-ultrasmall text-content-default-secondary"
            :class="ui?.copyright"
          >
            © 2026 СпортПортал. Все права защищены.
          </p>
        </ClientOnly>
      </template>
    </ClientOnly>
  </footer>
</template>

<script lang="ts" setup>
import { FOOTER_MENU, ORGANIZATION_DATA } from '~/shared'

defineOptions({
  name: 'SPFooter',
})

defineProps<{
  ui?: {
    root?: string
    logo?: string
    slogan?: string
    description?: string
    copyright?: string
    column?: string
    link?: string
    infoTitle?: string
    phone?: string
    email?: string
    scrollTopBtn?: string
  }
}>()

const breakpoints = useBreakpointsStore()
const { isMobile, isSmallTablet } = storeToRefs(breakpoints)

const scrollToTop = () => {
  if (import.meta.client) {
    window.scroll({
      behavior: 'smooth',
      top: 0,
    })
  }
}
</script>

<style lang="scss" scoped>
.footer {
  --footer-spacing: 20px;
  padding: 60px;
  max-width: calc(100% - var(--footer-spacing) * 2);
  margin-left: auto;
  margin-right: auto;
  background-color: var(--color-white);
  border-radius: 16px;

  @include isTablet {
    padding: 28px;
  }

  @include max-sm {
    padding: 20px;
    max-width: 100dvw;
    margin-left: 8.5px;
    margin-right: 8.5px;
  }
}

.logo-image {
  height: 36px;
}
</style>
